import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { MessageCircle, CalendarHeart } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-stone-50" data-id="element-73">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-74">
        <div className="absolute -top-[20%] -right-[10%] w-[600px] h-[600px] rounded-full bg-rose-100/50 blur-3xl" data-id="element-75" />
        <div className="absolute top-[40%] -left-[10%] w-[500px] h-[500px] rounded-full bg-amber-100/40 blur-3xl" data-id="element-76" />
      </div>

      <div className="container mx-auto px-4 relative z-10 text-center bg-[#FAF3F3F2]" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-78">
          <span className="inline-block py-1 px-3 rounded-full bg-rose-100 text-rose-600 text-sm font-semibold tracking-wide uppercase mb-6" data-id="element-79">
            Kitwe's Premier Event Planner
          </span>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-stone-900 mb-6 leading-tight" data-id="element-80">
            Mangalita <span className="text-rose-500" data-id="element-81">Events</span>
          </h1>

          <p className="text-xl md:text-2xl text-stone-600 max-w-2xl mx-auto mb-10 font-light leading-relaxed" data-id="element-82">
            Creating unforgettable celebrations with elegance and style. From
            intimate birthdays to grand weddings, we bring your vision to life.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-83">
            <a href="https://wa.me/260968642042" target="_blank" rel="noopener noreferrer" data-id="element-84">
              <Button size="lg" className="w-full sm:w-auto gap-2" data-id="element-85">
                <MessageCircle className="w-5 h-5" data-id="element-86" />
                Chat on WhatsApp
              </Button>
            </a>

            <a href="#services" data-id="element-87">
              <Button variant="outline" size="lg" className="w-full sm:w-auto gap-2" data-id="element-88">
                <CalendarHeart className="w-5 h-5" data-id="element-89" />
                View Services
              </Button>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}